import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'aid-title',
  template: `
    <div class="mat-subtitle-2 padding-bottom-16 aid-layout-row">
      <span class="basic-color-900">{{
        title | translate | sentancecase
      }}</span>
      @if (isRequired) {
        <span>*</span>
      }
    </div>
  `,
  styleUrls: ['./title.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class TitleComponent implements OnInit {
  @Input() title?: string;
  @Input() isRequired = false;
  constructor() {}

  ngOnInit() {}
}
